import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c2be2094&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c2be2094&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2be2094",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2be2094')) {
      api.createRecord('c2be2094', component.options)
    } else {
      api.reload('c2be2094', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c2be2094&scoped=true&lang=pug", function () {
      api.rerender('c2be2094', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/parentPage/index.vue"
export default component.exports